import React from 'react';
import { useApplication } from '../../context/ApplicationContext';
import FormField from '../FormField';
import SelectField from '../SelectField';

function PersonalInfoStep() {
  const { state, dispatch } = useApplication();
  const { formData } = state;

  const handleChange = (field, value) => {
    dispatch({
      type: 'UPDATE_FORM_DATA',
      payload: { [field]: value }
    });
  };

  const titleOptions = [
    { value: 'Mr', label: 'Mr.' },
    { value: 'Mrs', label: 'Mrs.' },
    { value: 'Miss', label: 'Miss' },
    { value: 'Dr', label: 'Dr.' },
    { value: 'Prof', label: 'Prof.' },
  ];

  const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
  ];

  const maritalStatusOptions = [
    { value: 'single', label: 'Single' },
    { value: 'married', label: 'Married' },
    { value: 'divorced', label: 'Divorced' },
    { value: 'widowed', label: 'Widowed' },
  ];

  return (
    <div className="space-y-6 w-full max-w-full overflow-x-hidden">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
        <SelectField
          label="Title"
          value={formData.title}
          onChange={(value) => handleChange('title', value)}
          options={titleOptions}
          required
          fieldName="title"
        />
        <FormField
          label="First Name"
          type="text"
          value={formData.firstName}
          onChange={(value) => handleChange('firstName', value)}
          required
          fieldName="firstName"
        />
        <FormField
          label="Middle Name"
          type="text"
          value={formData.middleName}
          onChange={(value) => handleChange('middleName', value)}
          fieldName="middleName"
        />
      </div>

      <FormField
        label="Last Name"
        type="text"
        value={formData.lastName}
        onChange={(value) => handleChange('lastName', value)}
        required
        fieldName="lastName"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        <FormField
          label="Date of Birth"
          type="date"
          value={formData.dateOfBirth}
          onChange={(value) => handleChange('dateOfBirth', value)}
          required
          fieldName="dateOfBirth"
        />
        <FormField
          label="Place of Birth"
          type="text"
          value={formData.placeOfBirth}
          onChange={(value) => handleChange('placeOfBirth', value)}
          required
          placeholder="City, Region"
          fieldName="placeOfBirth"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        <SelectField
          label="Gender"
          value={formData.gender}
          onChange={(value) => handleChange('gender', value)}
          options={genderOptions}
          required
          fieldName="gender"
        />
        <SelectField
          label="Marital Status"
          value={formData.maritalStatus}
          onChange={(value) => handleChange('maritalStatus', value)}
          options={maritalStatusOptions}
          required
          fieldName="maritalStatus"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        <FormField
          label="Nationality"
          type="text"
          value={formData.nationality}
          onChange={(value) => handleChange('nationality', value)}
          required
          placeholder="e.g., Ghanaian"
          fieldName="nationality"
        />
        <FormField
          label="Mother's Maiden Name"
          type="text"
          value={formData.mothersMaidenName}
          onChange={(value) => handleChange('mothersMaidenName', value)}
          required
          fieldName="mothersMaidenName"
        />
      </div>
    </div>
  );
}

export default PersonalInfoStep;